import React from "react";
import ReportDataTable from "./ReportDataTable";

const columns = [
  { label: "S/N", key: "serial", render: (row) => row.serial },
  { label: "Order Date", key: "date", render: (row) => String(row.date || "--------").slice(0, 10) },
  { label: "Order Time", key: "time" },
  { label: "Order Id", key: "order_id", render: (row) => row.o_id || row.order_id || row.id || "--------" },
  { label: "Table", key: "table_label", render: (row) => row.table_label || row.table_no || "--------" },
  { label: "Sub-Total(Rs.)", key: "amount", render: (row) => Number(row.amount || 0).toFixed(2) },
  { label: "Discount(Rs.)", key: "discount", render: (row) => Number(row.discount || 0).toFixed(2) },
  { label: "Grand Total(Rs.)", key: "grand_total", render: (row) => Number(row.grand_total || 0).toFixed(2) },
];

const DiscountReport = ({ rows = [], loading }) => (
  <ReportDataTable
    columns={columns}
    rows={rows.map((row, index) => ({ ...row, serial: index + 1 }))}
    loading={loading}
    emptyMessage="No discount report data found."
  />
);

export default DiscountReport;
